import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ecp-loginform',
  templateUrl: './ecp-loginform.component.html',
  styleUrls: ['./ecp-loginform.component.css']
})
export class EcpLoginformComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
